import { useCurrentUser } from "@src/context/UserContext";
import {
  hasOutstandingNominatedTerms,
  hasOutstandingPlatformTerms,
} from "@src/global_functions/backpackSdk/auth/termsAndConditions";
import backpackSdk from "@src/global_functions/backpackSdk/sdk";
import { Modal, Text } from "@src/straps/base";
import { useCallback, useState } from "react";
import ContactUsLink from "../ContactUsLink/ContactUsLink";
import {
  NominatorDataUseAgreement,
  TermsAndConditions,
} from "../TermsAndConditions";
import { AgreementCheckbox } from "./AgreementCheckbox";

export function useHasOutstandingTerms() {
  const { termsAndConditions } = useCurrentUser();
  return (
    hasOutstandingPlatformTerms(termsAndConditions) ||
    hasOutstandingNominatedTerms(termsAndConditions)
  );
}

export function DataUseAndPermissionModal() {
  const { termsAndConditions, refreshCurrentUser } = useCurrentUser();
  const { mutateAsync } = backpackSdk.auth.terms.mutations.usePostAcceptAll();

  const platformOutstanding = hasOutstandingPlatformTerms(termsAndConditions);
  const nominatedOutstanding = hasOutstandingNominatedTerms(termsAndConditions);
  const nominatedContent = termsAndConditions?.nominated?.content;

  const [termsChecked, setTermsChecked] = useState(false);
  const [nominatorChecked, setNominatorChecked] = useState(false);

  const confirm = useCallback(async () => {
    await mutateAsync();
    await refreshCurrentUser();
  }, [refreshCurrentUser, mutateAsync]);

  const submitDisabled =
    (platformOutstanding && !termsChecked) ||
    (nominatedOutstanding && !nominatorChecked);

  return (
    <Modal
      open={platformOutstanding || nominatedOutstanding}
      dismissible={false}
      trapFocus={false}
    >
      <Modal.Header
        title="Backpack's Terms, Conditions and Privacy Policy"
        variant="plain"
      />
      <div className="w-[540px] bg-white p-6">
        <div className="flex flex-col gap-5 pb-4">
          {platformOutstanding && (
            <AgreementCheckbox
              checked={termsChecked}
              onToggle={() => setTermsChecked(!termsChecked)}
              dataTestId="terms-checkbox"
            >
              <TermsAndConditions
                links={{
                  privacy: termsAndConditions?.privacy?.url,
                  website: termsAndConditions?.website?.url,
                  product: termsAndConditions?.product?.url,
                  marketplace: termsAndConditions?.marketplace?.url,
                }}
              />
            </AgreementCheckbox>
          )}
          {nominatedOutstanding && (
            <AgreementCheckbox
              checked={nominatorChecked}
              onToggle={() => setNominatorChecked(!nominatorChecked)}
              dataTestId="nomination-checkbox"
            >
              <NominatorDataUseAgreement content={nominatedContent} />
            </AgreementCheckbox>
          )}
        </div>
      </div>
      <Modal.Footer
        onSubmit={confirm}
        showCancel={false}
        submitText="I Agree"
        submitDisabled={submitDisabled}
      >
        <div>
          <Text variant="sb_t-14-500">Questions? We're here to help:</Text>
          <ContactUsLink />
        </div>
      </Modal.Footer>
    </Modal>
  );
}
